export const APP_FONT_SIZE_PERCENT_KEY = 'APP_FONT_SIZE_PERCENT_KEY';
export const APP_FONT_SIZE_PT_KEY = 'APP_FONT_SIZE_PT_KEY';
export const APP_LANGUAGE_KEY = 'APP_LANGUAGE_KEY';
export const ARCHIVED_VISIBLE_IN_LISTS_KEY = 'ARCHIVED_VISIBLE_IN_LISTS_KEY';
export const EDITOR_STANDARD_FONT_FAMILY_KEY = 'EDITOR_STANDARD_FONT_FAMILY_KEY';
export const EDITOR_STANDARD_FONT_SIZE_KEY = 'EDITOR_STANDARD_FONT_SIZE_KEY';
export const AVATAR_MODE_IN_LIST_KEY = 'AVATAR_MODE_IN_LIST_KEY';
export const BOTTOM_LEFT_MAIN_TOOLBAR_SLOT_KEY = 'BOTTOM_LEFT_MAIN_TOOLBAR_SLOT';
export const BOTTOM_RIGHT_MAIN_TOOLBAR_SLOT_KEY = 'BOTTOM_RIGHT_MAIN_TOOLBAR_SLOT';
export const CACHING_ENABLED = 'CACHING_ENABLED';
export const COMPACT_BUTTON_VIEW_KEY = 'COMPACT_BUTTON_VIEW_KEY';
export const DEFAULT_LIST_PER_MODULE_KEY = 'DEFAULT_LIST_PER_MODULE';
export const DETAIL_TOOLBAR_BUTTON_COLORS_KEY = 'DETAIL_TOOLBAR_BUTTON_COLORS_KEY';
export const DOCUMENT_PDF_PREVIEW_ZOOM_KEY = 'DOCUMENT_PDF_PREVIEW_ZOOM_KEY';
export const CONTROLS_MODE_KEY = 'CONTROLS_MODE_KEY';
export const DATE_FORMAT_KEY = 'DATE_FORMAT_KEY';
export const FINISHED_TRIGGERS_BACK_TO_LIST_KEY = 'FINISHED_TRIGGERS_BACK_TO_LIST_KEY';
export const HOVER_EFFECTS_KEY = 'HOVER_EFFECTS_KEY';
export const KANBAN_REMEMBER_LAST_BOARD_KEY = 'KANBAN_REMEMBER_LAST_BOARD';
export const LIST_GROUPING_MODE_KEY = 'LIST_GROUPING_MODE_KEY';
export const MENU_BOTTOM_SLOT_SORT_INVERSE_KEY = 'MENU_BOTTOM_SLOT_SORT_INVERSE_KEY';
export const NAVIGATION_MODE_KEY = 'NAVIGATION_MODE';
export const MENU_ITEMS_SOLID_KEY = 'MENU_ITEMS_SOLID';
export const MENU_ORDER_KEY = 'MAIN_MENU_ORDER';
export const NOTIFICATIONS_APPOINTMENT_ENABLED = 'NOTIFICATIONS_APPOINTMENT_ENABLED';
export const NOTIFICATIONS_DOCUMENTS_ENABLED = 'NOTIFICATIONS_DOCUMENTS_ENABLED';
export const NOTIFICATIONS_IDO_ENABLED = 'NOTIFICATIONS_IDO_ENABLED';
export const NOTIFICATIONS_MAIL_ENABLED = 'NOTIFICATIONS_MAIL_ENABLED';
export const NOTIFICATIONS_MESSAGE_ENABLED = 'NOTIFICATIONS_MESSAGE_ENABLED';
export const NOTIFICATIONS_NOTES_ENABLED = 'NOTIFICATIONS_NOTES_ENABLED';
export const NOTIFICATIONS_PHONE_CALLS_ENABLED = 'NOTIFICATIONS_PHONE_CALLS_ENABLED';
export const NOTIFICATIONS_TASKS_ENABLED = 'NOTIFICATIONS_TASKS_ENABLED';
export const SELECTED_COLOR_SCHEME_FOR_THE_INSTANCE_KEY = 'SELECTED_COLOR_SCHEME_FOR_THE_INSTANCE_KEY';
export const SETUP_WIZARD_COMPLETED_KEY = 'SETUP_WIZARD_COMPLETED_KEY';
export const SHARING_VISIBLE_IN_LISTS_KEY = 'SHARING_VISIBLE_IN_LISTS_KEY';
export const SMOOTH_ANIMATIONS_KEY = 'SMOOTH_ANIMATIONS_KEY';
export const SOFT_SHADOWS_KEY = 'SOFT_SHADOWS_KEY';
export const SPLIT_VIEW_ENABLED = 'SPLIT_VIEW_ENABLED';
export const SPOTLIGHT_SEARCH_ENABLED = 'SPOTLIGHT_SEARCH_ENABLED';
export const THEME_MODE_KEY = 'THEME_MODE_KEY';
export const THEME_PRIMARY_COLOR_KEY = 'THEME_PRIMARY_COLOR_KEY';
export const THEME_PRIMARY_COLOR_CUSTOM_KEY = 'THEME_PRIMARY_COLOR_CUSTOM_KEY';
export const THEME_SURFACE_COLOR_KEY = 'THEME_SURFACE_COLOR_KEY';
export const THEME_SURFACE_COLOR_CUSTOM_KEY = 'THEME_SURFACE_COLOR_CUSTOM_KEY';
export const TIME_ZONE = 'TIME_ZONE';
export const TOP_LEFT_MAIN_TOOLBAR_SLOT_KEY = 'TOP_LEFT_MAIN_TOOLBAR_SLOT';
export const TOP_RIGHT_MAIN_TOOLBAR_SLOT_KEY = 'TOP_RIGHT_MAIN_TOOLBAR_SLOT';
export const UNI_COLOR_BUTTONS_KEY = 'UNI_COLOR_BUTTONS_KEY';
export const USER_ONLINE_POSITION_KEY = 'USER_ONLINE_POSITION_KEY';
export const USER_ONLINE_LIST_VIEW_MODE = 'USER_ONLINE_LIST_VIEW_MODE';
export const USER_ONLINE_SHOW_OFFLINE_USERS = 'USER_ONLINE_SHOW_OFFLINE_USERS';
export const WORKSPACE_TABS_CREATE_ACTIONS_IN_SPLIT_VIEW = 'WORKSPACE_TABS_CREATE_ACTIONS_IN_SPLIT_VIEW';
export const WORKSPACE_TABS_ENABLED = 'WORKSPACE_TABS_ENABLED';
export const WORKSPACE_TABS_POSITION = 'WORKSPACE_TABS_POSITION';
export const WORKSPACE_TABS_RECORDS_IN_SPLIT_VIEW = 'WORKSPACE_TABS_RECORDS_IN_SPLIT_VIEW';
